import CreateNewPassword from "../../views/CreateNewPassword";

const CreateNewPasswordPage = () => {
  return (
    <div className=" h-screen">
      <CreateNewPassword />
    </div>
  );
};

export default CreateNewPasswordPage;
